<template>
  <div class="download-card">
    <img src="@/assets/icons/code.svg" class="download-icon" alt="Code Icon" />

    <h2 class="download-title">
      &hellip;or send it yourself for free
    </h2>

    <p class="download-subtitle mb-0">
      Export the HTML code of your design.
    </p>

    <p class="download-subtitle">
      <strong>Important things to remember&hellip;</strong>
    </p>

    <ul class="download-list">
      <li class="download-list-item">
        <img
          src="@/assets/icons/warning.svg"
          alt="Warning Icon"
          class="warning-icon"
        />
        Images and links will
        <strong>
          stop
        </strong>
        working if you uninstall Promo
      </li>
      <li class="download-list-item">
        <img
          src="@/assets/icons/warning.svg"
          alt="Warning Icon"
          class="warning-icon"
        />
        You will need to manage unsubscribes and mailing lists
      </li>
      <li class="download-list-item">
        <img
          src="@/assets/icons/warning.svg"
          alt="Warning Icon"
          class="warning-icon"
        />
        You will need to setup your own analytics and tracking
      </li>
      <li class="download-list-item">
        <img
          src="@/assets/icons/warning.svg"
          alt="Warning Icon"
          class="warning-icon"
        />
        Check your SPAM ratings and validation scores
      </li>
      <li class="download-list-item">
        <img
          src="@/assets/icons/warning.svg"
          alt="Warning Icon"
          class="warning-icon"
        />
        Validate email addresses before sending
      </li>
    </ul>

    <Button
      class="link download-button"
      :disabled="!canDownload"
      @click="onDownloadClick"
    >
      Download Newsletter
    </Button>

    <p v-if="!canDownload" class="no-download-helper">
      <strong>🤔 Can't download?</strong><br />Please check the reason at the
      top of the page.
    </p>
  </div>
</template>

<script>
export default {
  name: "DownloadCard",

  props: {
    accountId: {
      type: String,
      default: "",
    },
    campaignId: {
      type: String,
      default: "",
    },
    canDownload: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onDownloadClick() {
      // Show the download modal...
      this.$modal.show("download-campaign", {
        campaignId: this.campaignId,
      });
    },
  },
};
</script>

<style scoped>
.download-card {
  @apply px-6 text-center mb-12;

  @screen lg {
    @apply mb-0;
  }
}

.download-icon {
  width: 50px;
}

.download-title {
  @apply text-base text-support mb-3;
}

.download-subtitle {
  @apply text-xs text-grey-darker;
}

.download-list {
  @apply list-reset m-0;
}

.download-list-item {
  @apply text-xs font-sans font-medium text-grey-darkest;
}

.warning-icon {
  @apply m-0;
  width: 12px;

  @screen sm {
    @apply mr-1;
  }

  @screen lg {
    @apply relative;
    top: 1px;
    width: 14px;
  }
}

.download-button {
  @apply text-brand font-bold text-xs mx-auto;
}

.no-download-helper {
  @apply text-danger mb-0 inline-block;
  font-size: 12px;
}
</style>
